import { jsx as r, jsxs as P } from "react/jsx-runtime";
import x, { useContext as f, useEffect as I, createContext as L, useState as g, useMemo as h } from "react";
import d from "./combobox.js";
import A from "../hooks/useUserPatients.js";
const M = (i, e, a) => w(i, e[a]);
function C({
  searchKey: i,
  onSelectPatient: e,
  filterFn: a = M,
  ...s
}) {
  const n = A(), [o, t] = g(""), p = h(() => new WeakMap(n.map((c, l) => [c, l])), [n]), u = n.filter((c) => a(o, c, i));
  return /* @__PURE__ */ r(
    m.Provider,
    {
      value: { search: o, setSearch: t, filteredPatients: u, patients: n, patientsMap: p, searchKey: i },
      children: /* @__PURE__ */ r(
        d,
        {
          onSelectOption: (c) => {
            e?.(n.find((l) => l.id === c));
          },
          ...s
        }
      )
    }
  );
}
const S = x.forwardRef(
  /**
   * @param {React.ComponentProps<typeof Combobox.Input> & {defaultValue?: string}} props
   * @param {React.Ref<HTMLInputElement>} ref
   */
  function({ defaultValue: e, onChange: a, ...s }, n) {
    const { search: o, setSearch: t } = f(m);
    I(() => {
      e != null && t(e);
    }, []);
    function p(u) {
      t(u.target.value), a?.(u);
    }
    return /* @__PURE__ */ r(
      d.Input,
      {
        ref: n,
        defaultValue: o,
        onChange: p,
        ...s
      }
    );
  }
);
function _({ children: i, ...e }) {
  const { filteredPatients: a, patientsMap: s, searchKey: n } = f(m), o = h(() => a.reduce((t, p) => t + s.get(p), "").slice(1), [a, s]);
  return /* @__PURE__ */ r(d.Listbox, { ...e, children: a.map((t) => /* @__PURE__ */ P(
    d.Option,
    {
      value: t._id,
      children: [
        /* @__PURE__ */ r(
          "span",
          {
            "data-part": "patient-name",
            "data-emphasis": n === "patientName",
            children: t.patientName
          }
        ),
        /* @__PURE__ */ r(
          "span",
          {
            "data-part": "patient-id",
            "data-emphasis": n === "patientId",
            children: t.patientId
          }
        )
      ]
    },
    o + "-" + s.get(t)
  )) });
}
C.Input = S;
C.List = _;
const m = L({
  search: "",
  /** @type {React.Dispatch<React.SetStateAction<string>>} */
  setSearch() {
  },
  filteredPatients: [],
  patients: [],
  patientsMap: /* @__PURE__ */ new WeakMap(),
  searchKey: ""
});
function w(i = "", e = "") {
  return e.toLowerCase().includes(i.toLowerCase());
}
export {
  C as PatientAutoComplete
};
